<template>
  <div class="student-a-lesson">
    <div class="name"> {{ name }}的课程表 </div>
    <div v-for="(item, index) in studentInfoList" :key="index" class="studen-lensson-info" :class="{ active: toWeek === item.timeWeek }">
      <div class="left-week">
        <div class="week-text">
          星期{{ getWeekText(item.timeWeek) }}
        </div>
      </div>
      <div class="time-box">
        <div class="time-title" v-for="(item_min, index_min) in item.times" :key="index_min">
          <div class="lesson-name"> {{ item.lenssonName[index_min] }} </div>
          <div class="time-text"> {{ item_min }} </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {  getStudentInfoLesson } from '@api/user'

  import { getWeek, addZoo, sort } from '@common'

  export default {
    name: 'StudentALesson',
    data() {
      return {
        studentInfoList: [],
        toWeek: getWeek(),
        name: ''
      }
    },
    mounted() {
      this.getStudentInfo();
    },
    methods: {
      getStudentInfo() {
        getStudentInfoLesson(this.$route.params.uid).then(res => {
          this.name = res.data[0].student_name;
          let resList = res.data;
          for (let item of resList) {
            this.studentInfoList.push({
              name: item.student_name,
              lenssonName: [item.store_name],
              time: Number(item.start_time+"000"),
              timeWeek: getWeek(Number(item.start_time+"000")),
              times: [new Date(Number(item.start_time+"000")).getHours() +":"+ addZoo(new Date(Number(item.start_time+"000")).getMinutes())],
            })
          }
          sort(this.studentInfoList,'time'); //时间排序
          sort(this.studentInfoList,'timeWeek'); //周期排序
          let arr = [];
          let count = 0;
          let add = 0;
          for (let i = 0; i < this.studentInfoList.length; i++) {
            if (this.studentInfoList.length === 1) {
              arr[add] = [this.studentInfoList[0]];
              count = i;
              add++;
            }else if(i+1 !== this.studentInfoList.length) {
              if(this.studentInfoList[i+1] && (this.studentInfoList[i].timeWeek !== this.studentInfoList[i+1].timeWeek)) {
                if (i) {
                  arr[add] = this.studentInfoList.slice(count+1,i+1);
                }else {
                  arr[add] = [this.studentInfoList[0]];
                }
                count = i;
                add++;
              }
              if (i+2 === this.studentInfoList.length) {
                arr[add] = [this.studentInfoList[i+1]];
              }
            }
          }
          for (let i = 0; i < arr.length; i++) {
            for (let j = 0; j < arr[i].length; j++) {
              if(j+1 !== arr[i].length) {
                arr[i][0].times.push(arr[i][j+1].times.join(''));
                arr[i][0].lenssonName.push(arr[i][j+1].lenssonName.join(''));
              }
            }
            arr[i].splice(1,arr[i].length-1)
          }
          this.studentInfoList = arr.map(item => item[0]); //数组格式化类型赋值
        })
      },
      getWeekText(num) {
        let weekList = ['一','二','三','四','五','六','日']
        return weekList[num-1];
      },
    }
  }
</script>

<style scoped>
  .student-a-lesson {
    width: 100vw;
    height: 100vh;
    position: relative;
    background-color: rgb(255, 255, 255);
    padding: 0.3rem;
    padding-top: 1rem;
    overflow-y: scroll;
  }
    .name {
      font-size: 0.3rem;
      font-weight: 600;
      letter-spacing: 00.05rem;
      color: rgb(183, 127, 43);
      width: 100vw;
      left: 0;
      position: absolute;
      top: 0;
      height: 2rem;
      background: #e3efef;
      padding: 0.3rem;
    }
    .studen-lensson-info {
      position: relative;
      display: flex;
      background-color: rgb(235, 243, 243);
      box-shadow: 0.1rem 0.1rem 0.08rem rgb(226, 226, 226);
      margin-bottom: 0.3rem;
      padding: 0.2rem;
      min-height: 1.8rem;
      border-radius: 0.13rem;
      padding-left: 0.35rem;

    }
      .left-week {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
      }
        .week-text {
          font-size: 0.3rem;
          font-weight: 600;
          letter-spacing: 0.05rem;
          color: #3f8af3;
        }
      .time-box {
        flex: 1;
        padding: 0 0.1rem;
        display: flex;
        justify-content:space-between;
        flex-wrap: wrap;
        align-items: center;
      }
        .time-title {
          display: flex;
          width: 50%;
          align-items: center;
          justify-content: center;
          color: rgb(112, 111, 111);
          font-size: 0.25rem;
          font-weight: 600;
          min-height: 0.5rem;
        }
          .lesson-name {
            width: 1.7rem;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            word-break: break-all;
          }
      .active {
        background-color: rgb(240, 200, 103);
        color: rgb(255, 254, 250);
      }
      .active .week-text {
        color: rgb(255, 254, 250);
      }
      .active .time-title {
        color:rgb(255, 254, 250);
      }
</style>